import { ICustomerPhoneRepository } from 'modules/authentication/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisCustomerPhoneRepository from './implementations/VectisCustomerPhoneRepository';

let instance: ICustomerPhoneRepository | null = null;

export default function makeCustomerPhoneRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisCustomerPhoneRepository(httpProvider);
  }

  return instance;
}
